import { useDrag, useDrop } from "react-dnd";
import { useRef } from "react";

import { Row } from "./ColumnsSelection";

interface DragItem {
  name: string;
  index: number;
}

const DraggableRow = ({
  children,
  columnName,
  index,
  reorderRows,
  onClick,
}: {
  children: React.ReactNode;
  columnName: string;
  index: number;
  reorderRows: (dragIndex: number, hoverIndex: number) => void;
  onClick?: () => void;
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const [{ isOver }, drop] = useDrop<DragItem, void, { isOver: boolean }>({
    accept: "COLUMN",
    collect(monitor) {
      return {
        isOver: monitor.isOver({ shallow: true }),
      };
    },
    drop(item: DragItem) {
      if (!ref.current) {
        return;
      }

      const dragIndex = item.index;
      const hoverIndex = index;

      if (dragIndex === hoverIndex) {
        return;
      }

      reorderRows(dragIndex, hoverIndex);
    },
  });

  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "COLUMN",
      item: () => ({
        name: columnName,
        index,
      }),
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [columnName, index]
  );

  drag(drop(ref));

  return (
    <Row ref={ref} isDragging={isDragging} isOver={isOver} onClick={onClick}>
      {children}
    </Row>
  );
};

export default DraggableRow;
